<p>mng-activities works!</p>
